var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thumbnail"},[_c('div',{staticClass:"image"},[(_vm.imageUrl)?_c('img',{attrs:{"src":_vm.imageUrl,"alt":"imageurl"}}):_vm._e()]),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }